<div class="display-flex">
    <div class="col-md-3">
        <h4 mat-dialog-title>Screenshot</h4>
        <span class="ml-3"><a *ngIf="imageSource" [href]="imageSource" [download]="'Screen'"><i style="font-size: 18px;"
                    class="mdi mdi-download"></i></a></span>
    </div>
    <div class="col-md-6 mt-3 text-center">
        <button class="btn btn-circle rounded-circle btn-info theme-btn mr-2 btn-sm" (click)="zoomInClick()"
            ngbTooltip="Zoom In" placement="top">
            <i class="fas fa-search-plus"></i>
        </button>
        <button class="btn btn-circle rounded-circle btn-info theme-btn mr-2 btn-sm" (click)="zoomOutClick()"
            ngbTooltip="Zoom Out" placement="top">
            <i class="fas fa-search-minus "></i>
        </button>
        <button class="btn btn-circle rounded-circle btn-secondary mr-2 btn-sm" (click)="reset()" ngbTooltip="Reset"
            placement="top">
            <i class=" fas fa-redo"></i>
        </button>
    </div>
    <div class="col-md-3 text-right p-4">
        <a href="javascript:" mat-dialog-close><i class="fa fa-times-circle text-secondary"></i></a>
    </div>
</div>
<mat-dialog-content class="mat-typography" style="max-height: 390px;min-height: 390px;overflow:hidden;">
    <div class="row">
        <div class="col-md-12 mt-2 mb-2 text-center" #container style="height:380px;overflow: auto;">
            <img width="100%" height="auto" [src]="imageSource ? imageSource: '/assets/images/noimage.jpg'"
                (click)="onClick($event)" (mousedown)="onMouseDown($event)" (mousemove)="mouseMoveHandler($event)"
                #screenshot style="cursor : zoom-in; width:100%; transition: all .3s; " alt="No Screenshot" />
        </div>
    </div>
</mat-dialog-content>